export { default as default } from './SliderWrapper';
